<div class="qcontainer">
  <app-questionnaire-answer [claimId]="claimId!" [questionnaireId]="surveyId!" (completed)="onComplete()"></app-questionnaire-answer>
</div>
